export const DISABLE_STUDENT_OVERRIDES_CONFIG = 'disableCourseStudentOverrides'
